"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RevieveSkinDiagnosis = require("./RevieveSkinDiagnosis");
Object.keys(_RevieveSkinDiagnosis).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RevieveSkinDiagnosis[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RevieveSkinDiagnosis[key];
    }
  });
});
